<div class="container mx-auto p-8 mt-24">
  <h1 class="text-3xl font-bold mb-6">KPIs de Empaquetado</h1>

  <div class="bg-white rounded-lg shadow p-4 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Desde</label>
        <input type="date" [(ngModel)]="fromDate" class="w-full border rounded px-3 py-2">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Hasta</label>
        <input type="date" [(ngModel)]="toDate" class="w-full border rounded px-3 py-2">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Empaquetador</label>
        <select [(ngModel)]="selectedPackager" class="w-full border rounded px-3 py-2">
          <option [ngValue]="null">Todos</option>
          <option *ngFor="let packager of availablePackagers" [ngValue]="packager">{{ packager }}</option>
        </select>
      </div>
      <div class="flex flex-wrap items-end gap-2">
        <button (click)="applyFilters()" class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Aplicar</button>
        <button (click)="clearFilters()" class="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300">Limpiar</button>
        <button
          type="button"
          (click)="exportSummaryToExcel()"
          [disabled]="!canExportSummary()"
          class="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
          title="Exportar pestaña Resumen">
          <i class="fas fa-file-excel mr-1"></i>
          Excel resumen
        </button>
        <button
          type="button"
          (click)="exportDailyToExcel()"
          [disabled]="!canExportDaily()"
          class="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
          title="Exportar pestaña Resumen por día">
          <i class="fas fa-file-excel mr-1"></i>
          Excel por día
        </button>
      </div>
    </div>
  </div>

  <div class="flex border-b border-gray-200 mb-6">
    <button
      type="button"
      (click)="setActiveTab('summary')"
      class="px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors"
      [class.border-blue-600]="activeTab === 'summary'"
      [class.text-blue-600]="activeTab === 'summary'"
      [class.border-transparent]="activeTab !== 'summary'"
      [class.text-gray-600]="activeTab !== 'summary'"
      [class.hover:text-gray-800]="activeTab !== 'summary'">
      Resumen
    </button>
    <button
      type="button"
      (click)="setActiveTab('daily')"
      class="px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors"
      [class.border-blue-600]="activeTab === 'daily'"
      [class.text-blue-600]="activeTab === 'daily'"
      [class.border-transparent]="activeTab !== 'daily'"
      [class.text-gray-600]="activeTab !== 'daily'"
      [class.hover:text-gray-800]="activeTab !== 'daily'">
      Resumen por día
    </button>
  </div>

  <div *ngIf="errorMessage" class="bg-red-50 border border-red-200 text-red-700 p-3 rounded mb-6">
    {{ errorMessage }}
  </div>

  <div *ngIf="loading" class="text-gray-600">Cargando KPIs...</div>

  <!-- Pestaña Resumen -->
  <div *ngIf="!loading && activeTab === 'summary' && kpiData" class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div class="bg-white rounded-lg shadow p-4">
        <p class="text-sm text-gray-500">Paquetes totales</p>
        <p class="text-2xl font-bold">{{ kpiData.totalPackages }}</p>
      </div>
      <div class="bg-white rounded-lg shadow p-4">
        <p class="text-sm text-gray-500">Piezas totales</p>
        <p class="text-2xl font-bold">{{ kpiData.totalSpareParts }}</p>
      </div>
      <div class="bg-white rounded-lg shadow p-4">
        <p class="text-sm text-gray-500">Promedio piezas/paquete</p>
        <p class="text-2xl font-bold">{{ kpiData.averagePartsPerPackage | number:'1.2-2' }}</p>
      </div>
      <div class="bg-white rounded-lg shadow p-4">
        <p class="text-sm text-gray-500">Productividad diaria</p>
        <p class="text-2xl font-bold">{{ kpiData.dailyProductivityPackages | number:'1.2-2' }}</p>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow p-4 overflow-x-auto">
      <h2 class="text-lg font-semibold mb-3">Resumen por empaquetador</h2>
      <table class="min-w-full text-sm">
        <thead>
          <tr class="border-b text-left">
            <th class="py-2 pr-4">Empaquetador</th>
            <th class="py-2 pr-4">Paquetes</th>
            <th class="py-2 pr-4">Piezas</th>
            <th class="py-2 pr-4">Promedio piezas/paquete</th>
            <th class="py-2">Productividad diaria</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of kpiData.packagers" class="border-b">
            <td class="py-2 pr-4">{{ item.packager }}</td>
            <td class="py-2 pr-4">{{ item.packagesCount }}</td>
            <td class="py-2 pr-4">{{ item.sparePartsCount }}</td>
            <td class="py-2 pr-4">{{ item.averagePartsPerPackage | number:'1.2-2' }}</td>
            <td class="py-2">{{ item.dailyProductivityPackages | number:'1.2-2' }}</td>
          </tr>
          <tr *ngIf="kpiData.packagers.length === 0">
            <td colspan="5" class="py-4 text-center text-gray-500">No hay eventos de empaquetado para los filtros seleccionados.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Pestaña Resumen por día -->
  <div *ngIf="!loading && activeTab === 'daily' && dailyKpiData" class="space-y-6">
    <div class="bg-white rounded-lg shadow p-4 overflow-x-auto">
      <h2 class="text-lg font-semibold mb-3">Detalle por día y empaquetador</h2>
      <table class="min-w-full text-sm">
        <thead>
          <tr class="border-b text-left">
            <th class="py-2 pr-4">Fecha</th>
            <th class="py-2 pr-4">Empaquetador</th>
            <th class="py-2 pr-4">Paquetes</th>
            <th class="py-2 pr-4">Piezas</th>
            <th class="py-2">Promedio piezas/paquete</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of dailyKpiData.rows" class="border-b">
            <td class="py-2 pr-4">{{ formatDateForDisplay(row.date) }}</td>
            <td class="py-2 pr-4">{{ row.packager }}</td>
            <td class="py-2 pr-4">{{ row.packagesCount }}</td>
            <td class="py-2 pr-4">{{ row.sparePartsCount }}</td>
            <td class="py-2">{{ row.averagePartsPerPackage | number:'1.2-2' }}</td>
          </tr>
          <tr *ngIf="dailyKpiData.rows.length === 0">
            <td colspan="5" class="py-4 text-center text-gray-500">No hay eventos de empaquetado para los filtros seleccionados.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bg-white rounded-lg shadow p-4 overflow-x-auto">
      <h2 class="text-lg font-semibold mb-3">Totales por día</h2>
      <table class="min-w-full text-sm">
        <thead>
          <tr class="border-b text-left">
            <th class="py-2 pr-4">Fecha</th>
            <th class="py-2 pr-4">Paquetes</th>
            <th class="py-2 pr-4">Piezas</th>
            <th class="py-2">Promedio piezas/paquete</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let total of dailyKpiData.totalsByDate" class="border-b">
            <td class="py-2 pr-4 font-medium">{{ formatDateForDisplay(total.date) }}</td>
            <td class="py-2 pr-4">{{ total.packagesCount }}</td>
            <td class="py-2 pr-4">{{ total.sparePartsCount }}</td>
            <td class="py-2">{{ total.averagePartsPerPackage | number:'1.2-2' }}</td>
          </tr>
          <tr *ngIf="dailyKpiData.totalsByDate.length === 0">
            <td colspan="4" class="py-4 text-center text-gray-500">No hay totales para el período seleccionado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
